import { gql } from '@apollo/client'

export const SEARCH_NAME = gql`
query ($searchText: String!) {
  people: peopleByName (name: $searchText) { 
      darn
      surname
      firstname
      position
      staff { position department }
      pubRep { position province legislature }
      candidate { elections }
  }
}`

export const PERSON_DARN = gql`
query ($darn: Int!) {
  person: personByDARN(darn: $darn) { 
      darn
      surname
      firstname
      cellphone
      email
      position
      staff { position department employeeNumber }
      pubRep { position province legislature }
      candidate { elections }
  }
}
`

export const PERSON_ID = gql`
query ($idnumber: String!) {
  person: personByIDNumber(idnumber: $idnumber) { 
      darn
      surname
      firstname
      cellphone
      email
      position
      voter { registered registeredVd }
      member { branch memberNumber joinDate expiryDate }
      staff { position department employeeNumber }
      pubRep { position province legislature }
      candidate { elections }
  }
}
`
